import { Button, Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import Page from '../../../../packages/common/shared-ui/src/components/Page';
import { useTranslation } from '../../../../packages/common/utils/getLocalString';

import ArtCommon from './components/ArtCommon';
import ArtCustomers from './components/ArtCustomers';
import ArtTrackers from './components/ArtTrackers';

const Art = () => {
  const getLocalString = useTranslation();
  const navigate = useNavigate();
  const pageTitle = getLocalString('AdminArt', 'title');
  const childRef = useRef();
  const [formChanged, setFormChanged] = useState(false);
  const handleError = useCallback(
    error => {
      if (error) {
        navigate(`/errors/error-${error.status}`);
      }
    },
    [navigate],
  );

  return (
    <Page title={pageTitle} width='100%'>
      <Grid
        container
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Grid>
          <Typography
            variant='h1'
            sx={{
              m: 0,
              padding: '10px 0',
            }}
          >
            {pageTitle}
          </Typography>
        </Grid>
        <Grid>
          <Grid>
            <Button
              variant='defaultGreyPrimary'
              disableRipple
              onClick={event => childRef.current.save(event)}
              disabled={!formChanged}
            >
              <Typography
                variant='h4'
                sx={{
                  fontWeight: 700,
                }}
              >
                {getLocalString('buttons', 'save')}
              </Typography>
            </Button>
            <Button
              variant='defaultGreyPrimary'
              disableRipple
              sx={{ marginLeft: '8px' }}
              disabled={!formChanged}
              onClick={event => childRef.current.cancel(event)}
            >
              <Typography
                variant='h4'
                sx={{
                  fontWeight: 700,
                }}
              >
                {getLocalString('buttons', 'cancel')}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <ArtCommon
        ref={childRef}
        formChanged={value => setFormChanged(value)}
        handleError={error => handleError(error)}
      ></ArtCommon>
      <ArtTrackers handleError={error => handleError(error)}></ArtTrackers>
      <ArtCustomers handleError={error => handleError(error)}></ArtCustomers>
    </Page>
  );
};

export default Art;
